import { useQuery } from '@tanstack/react-query';
import { Action, Resource } from '@amzn/fae-auth-service';
import { OptionDefinition } from 'src/common/types/OptionDefinition';
import { AuthServiceApi } from 'src/api/AuthServiceApi';
import QueryKey from 'src/api/QueryKey';

// logic to dynamically populate regions for FC Fixed from FAE-AUTH-Service based on required combination of business and methodology
export const extractRegionsFromResponse = (
  authorizedCombinations: any[] = [],
): OptionDefinition[] => {
  const regions = new Set<string>();

  authorizedCombinations.forEach((combination) => {
    if (combination.methodology === 'FCFIXED_ALLOCATION') {
      combination.regions?.forEach((regionObj: any) => {
        Object.keys(regionObj).forEach((region) => {
          regions.add(region);
        });
      });
    }
  });

  return Array.from(regions).map((region) => ({
    label: region,
    value: region,
  }));
};

export const useRegionOptions = () =>
  useQuery({
    queryKey: [
      QueryKey.GetPermissionsByBusiness,
      Action.CREATE,
      Resource.TASK,
      'FCFIXED_ALLOCATION',
    ],
    queryFn: () => {
      const requestObj = {
        action: Action.CREATE,
        resource: Resource.TASK,
        business: 'FCFIXED_ALLOCATION',
      };
      return AuthServiceApi.getPermissionsByBusinessRequest(requestObj);
    },
    select: (data) => extractRegionsFromResponse(data.authorizedCombinations),
  });
